import { render } from "./PreadmissionNotes.vue?vue&type=template&id=2ccfe239"
import script from "./PreadmissionNotes.ts?vue&type=script&lang=js&external"
export * from "./PreadmissionNotes.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__